import { FormulaConfiguration } from "./formula-configuration";

export class FormulaGroup {

    id: number = 0;
    description!: string;
    formulaConfigurations: FormulaConfiguration [] = [];

}